<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <h5 class="grey--text">Vista general</h5>
    <v-row>
      <v-col cols="12">
        <h2 class="deep-purple--text lighten-3">
          {{ $t('calendar_types.all_calendar_types') }}
        </h2>
      </v-col>
    </v-row>
    <calendar-types-data-table
      :table-loading="loading"
      :items="calendarTypes"
      @refresh="handleRefresh"
    ></calendar-types-data-table>
  </v-container>
</template>

<script>
import CalendarTypesDataTable from '@/components/calendarTypes/CalendarTypesDataTable.vue';
import LoadingMixin from '@/mixins/loading';
import snackbarMixin from '@/mixins/snackbar';
import calendarTypeService from '@/services/calendarType.service';

export default {
  name: 'CalendarTypes',
  components: {
    CalendarTypesDataTable,
  },
  mixins: [LoadingMixin, snackbarMixin],
  data: () => ({
    calendarTypes: [],
  }),
  mounted() {
    this.loadCalendarTypes();
  },
  methods: {
    handleRefresh() {
      this.loadCalendarTypes();
    },
    async loadCalendarTypes() {
      this.loader();
      try {
        const response = await calendarTypeService.findAll();
        if (response.status === 200) {
          this.calendarTypes = response.data || [];
        }
      } catch (error) {
        this.snackbarError(this.$t('calendar_types.error'));
      } finally {
        this.loader();
      }
    },
  },
};
</script>

<style scoped>
</style>
